import { ListedPropertyDetailMemberAuctionProperty } from 'domain/entities/PropertyEntity';
import { AUTH_ROUTES, PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import { commonHelpers } from 'utilities/helpers';
import { CountLike } from '../../../CU-002-01/components/CountLike';
import { TodoEntity } from '../../../CU-002-02/models/CardModel';
import { useAppSelector } from 'presentation/redux/hooks';

interface props {
    detailAssessment?: ListedPropertyDetailMemberAuctionProperty;
    countLike?: number;
    isBookmarked: boolean;
    onClickBookmark: () => void;
    currentTodo: TodoEntity;
    bidPrice: number;
    purchaseAmount: number;
}
const tier_1 = ['0001000080', '0001000090', '0001000100', '0001000110', '0001000120'];
export const MarketPrice = ({
    detailAssessment,
    countLike,
    isBookmarked,
    onClickBookmark,
    currentTodo,
    bidPrice,
}: props) => {
    const userSlice = useAppSelector((state) => state.user);
    const navigate = useNavigate();
    return (
        <section>
            <div
                className="center-inside row"
                style={{ height: 24, width: 'fit-content', marginTop: 16 }}
            >
                <section className="like-lable cell">{detailAssessment?.name}</section>
                <section className="cell"></section>
                <section
                    className="cell"
                    style={{ textAlign: 'right', marginRight: 8, cursor: 'pointer' }}
                    onClick={onClickBookmark}
                >
                    <CountLike value={countLike} currentBookmarked={isBookmarked} />
                </section>
            </div>
            {tier_1.includes(currentTodo.todoCode) && (
                <div
                    className="center-inside row"
                    style={{ height: 24, width: 'fit-content', marginTop: 16 }}
                >
                    <section className="mkp-label cell">現在の最高入札額</section>
                    <section className="cell" style={{ textAlign: 'right', marginRight: 8 }}>
                        <span className="mkp-number">
                            {commonHelpers
                                .roundTenThousandYen(detailAssessment?.currentHighestAuctionPrice)
                                .toLocaleString('en-US', {
                                    maximumFractionDigits: 2,
                                })}
                        </span>
                        <span className="mkp-unit"> 万円</span>
                    </section>
                </div>
            )}
            {tier_1.includes(currentTodo.todoCode) && (
                <div
                    className="center-inside row"
                    style={{ height: 24, width: 'fit-content', marginTop: 16 }}
                >
                    <section className="mkp-label cell">即決価格</section>
                    <section className="cell" style={{ textAlign: 'right', marginRight: 8 }}>
                        <span className="mkp-number">
                            {commonHelpers
                                .roundTenThousandYen(detailAssessment?.askingSalePriceUpperLimit)
                                .toLocaleString('en-US', {
                                    maximumFractionDigits: 2,
                                })}
                        </span>
                        <span className="mkp-unit"> 万円</span>
                    </section>
                </div>
            )}
            {tier_1.includes(currentTodo.todoCode) && (
                <div
                    className="center-inside row"
                    style={{ height: 24, width: 'fit-content', marginTop: 16 }}
                >
                    <section className="mkp-label cell">売却希望下限価格</section>
                    <section className="cell" style={{ textAlign: 'right', marginRight: 8 }}>
                        <span className="mkp-number">
                            {commonHelpers
                                .roundTenThousandYen(detailAssessment?.askingSalePriceLowerLimit)
                                .toLocaleString('en-US', {
                                    maximumFractionDigits: 2,
                                })}
                        </span>
                        <span className="mkp-unit"> 万円</span>
                    </section>
                </div>
            )}
            {tier_1.includes(currentTodo.todoCode) && (
                <div
                    className="center-inside row"
                    style={{ height: 24, width: 'fit-content', marginTop: 16 }}
                >
                    <section className="mkp-label cell">当社買取価格</section>
                    <section className="cell" style={{ textAlign: 'right', marginRight: 8 }}>
                        <span className="mkp-number">
                            {commonHelpers
                                .roundTenThousandYen(detailAssessment?.nrbxPrice)
                                .toLocaleString('en-US', {
                                    maximumFractionDigits: 2,
                                })}
                        </span>
                        <span className="mkp-unit"> 万円</span>
                    </section>
                </div>
            )}
            {!tier_1.includes(currentTodo.todoCode) && (
                <div
                    className="center-inside row"
                    style={{ height: 24, width: 'fit-content', marginTop: 16 }}
                >
                    <section className="mkp-label cell">売却価格</section>
                    <section className="cell" style={{ textAlign: 'right', marginRight: 8 }}>
                        <span className="mkp-number">
                            {commonHelpers.roundTenThousandYen(bidPrice).toLocaleString('en-US', {
                                maximumFractionDigits: 2,
                            })}
                        </span>
                        <span className="mkp-unit"> 万円</span>
                    </section>
                </div>
            )}
            {(!userSlice.isSignedIn && (
                <section>
                    <p>※ 最低落札価格が設定されています。</p>
                    <div style={{ display: 'flex', width: '100%' }}>
                        <div style={{ width: '50%' }}>
                            <p style={{ textAlign: 'center' }}>
                                シミュレーションは登録不要でご利用いただけます。
                            </p>
                            <div
                                className="form-button simulate-form-button"
                                onClick={() =>
                                    !detailAssessment?.isLogin
                                        ? navigate(
                                              `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_051_01}`,
                                          )
                                        : null
                                }
                            >
                                シミュレーションへ
                            </div>
                        </div>
                        <div style={{ width: '50%' }}>
                            <p style={{ textAlign: 'center' }}>
                                もっと知りたい方はログインが必要です。
                            </p>
                            <div
                                className="form-button login-form-button"
                                onClick={() =>
                                    navigate(`${AUTH_ROUTES.PATH}/${AUTH_ROUTES.SUB.CU_001_00}`)
                                }
                            >
                                ログイン・アカウント作成へ
                            </div>
                        </div>
                    </div>
                </section>
            )) || <section style={{ border: '1px solid', marginTop: 20 }}></section>}
        </section>
    );
};
